export const NEED_LOGGED_IN_MESSAGE = 'You need to be logged-in';
